import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Table, ButtonGroup, Glyphicon } from 'react-bootstrap'
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/pages/admin"

class ContentOverzicht extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.getPages = this.getPages.bind(this)
        this.state = {
            pages: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: FETCH_URL // To know where to fetch (to refresh pages) if a company is deleted
        }
    }

    // To pass parameters to event handlers while using property initializer syntax, we need to use currying.   
    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `${FETCH_URL}/${id}`
        if (window.confirm('Are you sure you wish to delete this item?'))
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                Api.print(`Response delete page with id: ${id}`)
                Api.print(response)
                this.getPages(this.state.currentFetchUrl) // Update the pages list
            })
    }

    getPages(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handleClick).then(response => {
            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            Api.print("Pages")
            Api.print(objectData)
            Api.print("----------")
            if (objectData !== undefined)
                this.setState({ pages: objectData.pages }); // Companies object
        })
    }

    componentDidMount() {
        this.getPages(FETCH_URL)
    }

    handleClick(e) {
        const fetchUrl = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.getPages(fetchUrl)
        this.setState({ currentFetchUrl: fetchUrl })
    }

    render() {
        let pages = this.state.pages
        return (
            <div>
                <Table responsive striped bordered hover>
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Url</th>
                            <th>Datum</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pages !== undefined ? pages.map((page) => {
                            let editUrl = `/admin/content/bewerken/${page.id}`
                            return (<tr key={page.id}>
                                <td>{page.title}</td>
                                <td>{page.url}</td>
                                <td>{Api.formatDate(page.dateCreated)}</td>
                                <td>
                                    <ButtonGroup>
                                        <LinkContainer to={editUrl}>
                                            <Button bsSize="xsmall" className="edit">
                                                <Glyphicon glyph="pencil" />
                                            </Button>
                                        </LinkContainer>
                                        <Button bsSize="xsmall" className="delete" onClick={this.handleDelete(page.id)}>
                                            <Glyphicon glyph="remove" />
                                        </Button>
                                    </ButtonGroup>
                                </td>
                            </tr>)
                        }) : null}
                    </tbody>
                </Table>
                <div className="paginationStyling">
                    <div style={{ float: 'left' }}>
                        {this.state.pagination.prevButton}
                    </div>
                    <div style={{ float: 'center' }}>
                        Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                    </div>
                    <div style={{ float: 'right' }}>
                        {this.state.pagination.nextButton}
                    </div>
                </div>
            </div>
        );
    }
}

export default ContentOverzicht;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Content/Overview.js